import React from 'react';
import './App.css';
import TestInRoom from './TestInRoom/TestInRoom';

class App extends React.Component {
  constructor(props){
    super(props);
    this.state ={

    };
  }

  render(){
     return (
      <div className="App">
        <p>Welcome to Ohanga</p>
        <TestInRoom></TestInRoom>
      </div>
     )
  }
}

export default App;
